export default "__VITE_ASSET__Bc2R45u$__"